import React, { useState, useEffect } from 'react';
import socketService from '../services/socketService';

export default function ConnectivityBanner() {
  const [connected, setConnected] = useState(true);

  useEffect(() => {
    const unsub = socketService.onConnectionChange((status) => {
      setConnected(status);
    });
    return unsub;
  }, []);

  if (connected) return null;

  return (
    <div className="connectivity-banner">
      <span className="banner-icon">📵</span>
      <span>No connection</span>
    </div>
  );
}
